import { render } from "./AHS_VDH_WIC.vue?vue&type=template&id=d7870190"
import script from "./AHS_VDH_WIC.vue?vue&type=script&lang=js"
export * from "./AHS_VDH_WIC.vue?vue&type=script&lang=js"

import "./AHS_VDH_WIC.vue?vue&type=style&index=0&id=d7870190&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__